export const GLOBAL = 'global';
export const GLOBAL_RECOMMENDATIONS = 'global.recommendations';
export const GLOBAL_ACCESSIBILITY = 'global.accessibility';
export const ctaText = `CTA_TEXT`;
export const ctaUrl = `CTA_URL`; // TODO - this needs to be removed as this is dynamic
export const ctaTitle = `CTA_TITLE`;
export const lblErrorOptimisticAddtobag = `lbl_error_optimistic_addtobag`;
export const lblHomepageTrendingInYourArea = `lbl_homepage_trending_in_your_area`;
export const lblHomepageRecentlyViewed = `lbl_homepage_recently_viewed`;
export const lblHomepageYouMayAlsoLike = `lbl_homepage_you_may_also_like`;
export const lblSimilarToProductsYouLove = `lbl_similar_to_products_you_love`;
export const youMayAlsoLike = `YOU MAY ALSO LIKE`;
export const nextIconButton = 'nextIconButton';
export const previousButton = 'previousButton';
export const repStr = 'BASED ON YOUR RECENT PURCHASE';
export const recentlyViewd = 'RECENTLY VIEWED';

export const RecommendationLabels = {
  global: {
    recommendations: {
      [ctaText]: 'Shop Now',
      [ctaUrl]: '/c/girls-clothing', // TODO - this needs to be removed as this is dynamic
      [ctaTitle]: 'Shop Now Title',
      [lblErrorOptimisticAddtobag]: 'We Found These Similar Items',
      [lblHomepageTrendingInYourArea]: 'Trending In Your Area',
      [lblHomepageRecentlyViewed]: recentlyViewd,
      [lblHomepageYouMayAlsoLike]: 'You May Also Like',
      [lblSimilarToProductsYouLove]: 'Similar To Products You Love',
    },
    accessibility: {
      [previousButton]: 'Previous',
      [nextIconButton]: 'next',
    },
  },
};
